<template>
  <div style="height: 100%;" class="head-wrap">
    <el-container style="height: 100%;">
      <el-header id="headBox">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <div class="f-fl"></div>
          </el-col>
          <el-col :span="12">
            <div class="f-fr">
              <div style="padding: 0;cursor:pointer;">
                <a href="http://jxc.jc-saas.com" style="color: #fff" target="_blank">商户后台</a>
              </div>
              <el-dropdown @commant="setClick">
                <span class="account el-dropdown-link">
                  {{account}}<i class="el-icon-arrow-down el-icon--right" style="vertical-align: middle;"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <span @click="refactorPass">修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <span @click="changePhone">更换手机号</span>
                  </el-dropdown-item>
                  <!--<el-dropdown-item>-->
                    <!--<span @click="logUpload">上传日志信息</span>-->
                  <!--</el-dropdown-item>-->
                  <el-dropdown-item>
                    <span @click="logOut">退出系统</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <router-view style="width: 100%;height:calc(100% - 60px);"/>
    </el-container>
    <!--修改密码-->
    <el-dialog title="修改密码" :visible.sync="innerVisible" width="450px" @close="resetPwdForm">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="旧 密 码：" prop="oldPassword">
          <el-input type="password" v-model="ruleForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新 密 码：" prop="password">
          <el-input type="password" v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="newPassword">
          <el-input type="password" v-model="ruleForm.newPassword"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="submitForm" class="total" type="primary" style="width:100%;">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--更换手机号-->
    <el-dialog title="更换手机号" :visible.sync="retrieve_phone" class="retrieve_pass" :modal-append-to-body="false" width="480px" @close="closePhoneDia">
      <div class="crumbs">
        <ul>
          <li :class="[active==1?'current':'']"><span>1.验证手机号</span></li>
          <li :class="[active==2?'current':'']"><span>2.设置新手机号</span></li>
          <!--<li :class="[active==3?'current':'']"><span>3.密码重置成功</span></li>-->
        </ul>
      </div>
      <el-form :model="resetForm1" ref="resetForm1" :rules="resetRules1" v-show="active==1" label-width="100px">
        <el-form-item label="原手机号：" prop="phoneNum">
          <el-input placeholder="请输入手机号" v-model="resetForm1.phoneNum" clearable maxlength="11" disabled></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="messageCode">
          <el-input placeholder="请在此输入验证码" v-model="resetForm1.messageCode" clearable maxlength="6">
            <el-button slot="append" @click="getCode" :disabled="reset.canGetCode">{{reset.loginCodeTxt}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item class="handle-btn-wrap clearfix">
          <el-button type="primary" style="width: 100%;" @click="next">下一步</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="resetForm2" ref="resetForm2" :rules="resetRules2" v-show="active==2" label-width="100px">
        <el-form-item label="新手机号：" prop="phoneNum">
          <el-input placeholder="请输入手机号" v-model="resetForm2.phoneNum" clearable maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="messageCode">
          <el-input placeholder="请在此输入验证码" v-model="resetForm2.messageCode" clearable maxlength="6">
            <el-button slot="append" @click="getCode2" :disabled="reset2.canGetCode">{{reset2.loginCodeTxt}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item class="handle-btn-wrap">
          <el-button style="width: 100%;" type="primary" @click="confirmPwd">确认修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import { removeToken } from '@/utils/auth.js'
  import Logan from 'logan-web'

  export default {
    props: {},
    data () {
      const newReg = (rule, value, callback) => {
        // let v = value.toString().trim();
        // let flag = /^[a-zA-Z0-9]{6,10}$/.test(value);
        if (value === '') {
          if (callback) {callback(new Error('请输入新密码'))}
        } else {
          callback()
        }
      }
      const confirmReg = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        account: JSON.parse(this.$Cookies.get('userInfo')).userName,   //当前用户
        ruleForm: {   //修改密码参数
          loginname: JSON.parse(this.$Cookies.get('userInfo')).phoneNum,
          oldPassword: '',
          password: '',
          newPassword: ''
        },
        rules: {    //修改密码规则
          oldPassword: [{required: true, message: '请输入旧密码',}],
          password: [{required: true, validator: this.$Util.RegExp.passwordReg}],
          newPassword: [{required: true, validator: confirmReg}]
        },
        innerVisible: false,
        retrieve_phone: false,
        active: 1,
        //更改手机号
        resetForm1: {
          phoneNum: JSON.parse(this.$Cookies.get('userInfo')).phoneNum,
          messageCode: ''
        },
        reset: {
          timer: null,
          count: 60,
          loginCodeTxt: '获取验证码',  // 登录获取验证码
          canGetCode: false,  //获取验证码按钮是否禁用
        },
        //重置密码验证规则1
        resetRules1: {
          phoneNum: [{required: true, validator: this.$Util.RegExp.phoneReg}],
          messageCode: [{required: true, message: '请输入验证码'}],
        },
        //重置密码 确认密码相同规则
        resetForm2: {
          phoneNum: '',
          messageCode: '',
          userId: JSON.parse(this.$Cookies.get('userInfo')).id
        },
        reset2: {
          timer: null,
          count: 60,
          loginCodeTxt: '获取验证码',  // 登录获取验证码
          canGetCode: false,  //获取验证码按钮是否禁用
        },
        resetRules2: {
          phoneNum: [{required: true, validator: this.$Util.RegExp.phoneReg}],
          messageCode: [{required: true, message: '请输入验证码',}],
        },
      }
    },
    methods: {
      resetPwdForm(){},
      setClick(){},
      // 修改手机号显隐
      changePhone () {
        this.retrieve_phone = true
      },
      //修改手机号获取验证码
      getCode () {
        this.$refs.resetForm1.validateField('phoneNum', (val) => {
          // 当val==''时表示校验通过
          if (val == '') {
            this.$ajaxPost('user/login/appSendMessage', {phoneNo: this.resetForm1.phoneNum}).then(({data}) => {
              if (data.responseCode == 200) {
                clearInterval(this.reset.timer)
                this.reset.timer = setInterval(() => {
                  if (this.reset.count == 0) {
                    clearInterval(this.reset.timer)
                    this.reset.loginCodeTxt = '获取验证码'
                    this.reset.canGetCode = false
                    this.reset.count = 60
                  } else {
                    this.reset.count--
                    this.reset.loginCodeTxt = '再次获取 ' + this.reset.count + ' s'
                    this.reset.canGetCode = true
                  }
                }, 1000)
                this.$message.success('验证码发送成功')
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          } else {
            return false
          }
        })
      },
      goHou () {
        window.location.href = 'http://jxc.jc-saas.com'
      },
      //下一步
      next () {
        this.$refs.resetForm1.validate(valid => {
          if (valid) {
            this.$ajaxPost('user/login/verifyMessageCodePC', {loginname: this.resetForm1.phoneNum, messageCode: this.resetForm1.messageCode}).then(({data}) => {
              if (data.responseCode == 200) {
                this.active = 2
                this.reset.loginCodeTxt = '获取验证码'
                this.reset.canGetCode = false
                this.reset.count = 60
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          }
        })
      },
      //修改手机号获取验证码
      getCode2 () {
        this.$refs.resetForm2.validateField('phoneNum', (val) => {
          // 当val==''时表示校验通过
          if (val == '') {
            this.$ajaxPost('user/login/appSendMessage', {phoneNo: this.resetForm2.phoneNum}).then(({data}) => {
              if (data.responseCode == 200) {
                clearInterval(this.reset2.timer)
                this.reset2.timer = setInterval(() => {
                  if (this.reset2.count == 0) {
                    clearInterval(this.reset2.timer)
                    this.reset2.loginCodeTxt = '获取验证码'
                    this.reset2.canGetCode = false
                    this.reset2.count = 60
                  } else {
                    this.reset2.count--
                    this.reset2.loginCodeTxt = '再次获取 ' + this.reset2.count + ' s'
                    this.reset2.canGetCode = true
                  }
                }, 1000)
                this.$message.success('验证码发送成功')
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          } else {
            return false
          }
        })
      },
      //确认修改
      confirmPwd () {
        this.$refs.resetForm2.validate(valid => {
          if (valid) {
            this.$ajaxPost('user/login/modifiedPhoneNumPC', this.resetForm2).then(({data}) => {
              if (data.responseCode == 200) {
                clearInterval(this.reset.timer)
                this.reset.loginCodeTxt = '获取验证码'
                this.reset.canGetCode = false
                this.reset.count = 60
                this.resetForm1.messageCode = ''
                clearInterval(this.reset2.timer)
                this.reset2.loginCodeTxt = '获取验证码'
                this.reset2.canGetCode = false
                this.reset2.count = 60
                this.resetForm2.phoneNum = ''
                this.resetForm2.messageCode = ''
                setTimeout(() => {
                  this.$message.success('更换成功')
                  this.retrieve_phone = false
                  this.active = 1
                }, 500)
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          }
        })
      },
      refactorPass () {   //显示 修改密码弹窗
        this.innerVisible = true
      },
      submitForm () {    //确认修改密码
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            //ruleForm
            let param = {loginName: this.ruleForm.loginname, password: this.ruleForm.newPassword}
            this.$ajaxPost('user/login/modifiedPassWordPC', param).then(({data}) => {
              if (data.responseCode == 200) {
                this.innerVisible = false
                this.resetForm()
                this.$message.success('密码修改成功！下次请用新密码登录')
              } else {
                this.$message.error(data.responseMsg)
              }
            })
            /*  this.$confirm('确认修改密码？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let json_ruleForm = JSON.stringify({
                  oldPassword: this.$md5(this.ruleForm.oldPassword),
                  password: this.$md5(this.ruleForm.password),
                  newPassword: this.$md5(this.ruleForm.newPassword)
                })
                this.$ajaxPost('user/login/modifiedPassWordPC', {reqParam: json_ruleForm}).then(({data}) => {
                  if (data.code == 200) {
                    this.innerVisible = false
                    this.resetForm()
                    this.$Cookies.set('loginToken', '')
                    this.$message.success('密码修改成功！请重新登录')
                    setTimeout(() => {
                      this.$router.push({path: '/login'}, () => {
                        window.location.reload()
                      })
                    }, 1000)
                  } else {
                    this.$message.error(data.msg)
                  }
                })
              }).catch(() => {})*/
          } else {
            return false
          }
        })
      },
      logOut () {   //退出登录
        this.$confirm('确认退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$Cookies.remove('loginForm')
          this.$Cookies.set('id', '')
          sessionStorage.clear()
          removeToken()
          this.$router.push({path: '/login'}, () => {
            this.$message.success('退出成功！')
          })
        }).catch(() => {})
      },
      resetForm () {   //重置修改密码表单
        this.$refs.ruleForm.resetFields()
      },
      // 关闭手机号弹窗
      closePhoneDia () {
        this.active = 1
      },
      async logUpload() {
        const date = new Date();
        const {id, userName} = this.$Cookies.get('userInfo');
        const reportResult = await Logan.report({
          reportUrl: `/api/logan/web/upload.json`,
          deviceId: 'LocalDeviceIdOrUnionIdWeb',
          fromDayString: date.formatDate(),
          toDayString: date.formatDate(),
          webSource: 'Chrome',
          environment: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/77.0.3865.120 Safari/537.36',
          customInfo: JSON.stringify({userId: id, userName, biz: 'Live Better'})
        });

        console.log(reportResult);
      }
    },
    components: {},
    mounted () {},
    watch: {
      retrieve_phone (val) {
        if (val == false) {
          this.$refs.resetForm1.clearValidate()
          this.$refs.resetForm2.clearValidate()
          clearInterval(this.reset.timer)
          this.reset.loginCodeTxt = '获取验证码'
          this.reset.canGetCode = false
          this.reset.count = 60
          this.resetForm1.messageCode = ''
          clearInterval(this.reset2.timer)
          this.reset2.loginCodeTxt = '获取验证码'
          this.reset2.canGetCode = false
          this.reset2.count = 60
          this.resetForm2.phoneNum = ''
          this.resetForm2.messageCode = ''
        }
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  #headBox {
    background: #537fb7;
    height: 60px !important;

    .f-fl {
      width: 340px;
      height: 45px;
      margin-top: 8px;
      background: url('../../assets/images/sprite.png') 0 9px no-repeat;
    }

    .f-fr {
      padding-top: 21px;

      div {
        float: left;
        height: 22px;
        line-height: 22px;
        padding: 0 25px;
        color: #fff;
        font-size: 16px;
        text-align: left;
      }

      .account {
        background: url('../../assets/images/sprite.png') 16px -764px no-repeat;
        padding-left: 45px;
      }

      .home {
        cursor: pointer;
        background: url('../../assets/images/sprite.png') 16px -428px no-repeat;
      }

      .log-out {
        cursor: pointer;
        background: url('../../assets/images/sprite.png') 16px -498px no-repeat;
      }

      .line {
        float: left;
        display: inline-block;
        position: relative;
        width: 1px;
        height: 14px;
        background-color: #fff;
        margin-top: 4px;
      }
    }

  }

  #app .head-wrap {
    /*步骤条*/
    .crumbs {
      text-align: center;
      margin-bottom: 40px;
      background: #fff;

      .current {
        span {
          color: #537fb7;

          &:after {
            border-left-color: #f4f4f4;
          }
        }
      }
    }

    .crumbs ul {
      list-style: none;
      display: inline-table;
      width: 100%;
    }

    .crumbs ul li {
      display: table-cell;
      width: 30%;
      text-align: center;
    }

    .crumbs ul li span {
      display: block;
      height: 40px;
      line-height: 40px;
      padding-left: 30px;
      background: #f4f4f4;
      color: #666;
      position: relative;
      margin: 0 10px 0 0;
      font-size: 14px;
      text-decoration: none;
    }

    .crumbs ul li span:after {
      content: "";
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #f4f4f4;
      position: absolute;
      right: -20px;
      top: 0;
      z-index: 1;
    }

    .crumbs ul li span:before {
      content: "";
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #fff;
      position: absolute;
      left: 0;
      top: 0;
    }

    .crumbs ul li:first-child span:before {
      display: none;
    }

    .crumbs ul li:last-child span {
      margin-right: 0;
    }

    .crumbs ul li:last-child span:after {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/layout/head.vue